export const MCS_COLOR = {
  13: '#85c583',
  12: '#93c882',
  11: '#9dcd82',
  10: '#a5d082',
  9: '#aed380',
  8: '#b4d680',
  7: '#bbd97f',
  6: '#ffe078',
  5: '#feda78',
  4: '#fcd379',
  3: '#fbcc79',
  2: '#dd7f82',
  1: '#f5e6e6',
  0: '#fef9f9',
};
